import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { SectionHeading } from "../../components/shared/SectionHeading";
import { EmptyState } from "../../components/shared/EmptyState";
import { ReviewsSection } from "../../components/shared/ReviewsSection";
import { api } from "../../lib/api";
import { usePageMedia } from "../../lib/usePageMedia";
import { usePageTexts } from "../../lib/usePageTexts";

export default function RealisationsPage() {
  const [items, setItems] = useState(null);
  const pageMedia = usePageMedia();
  const { text } = usePageTexts();
  const hero = pageMedia["realisations:hero"];
  useEffect(() => {
    api.get("/gallery").then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);
  const shown = items || [];

  return (
    <div className="container-ae py-12 md:py-16" data-testid="realisations-page">
      <SectionHeading overline="Réalisations & Galerie" title="Nos événements" accent="en images">
        {text("realisations:intro", "Chaque réalisation est publiée volontairement par Art Event, avec l'accord de ses clients.")}
      </SectionHeading>
      {hero && (
        <img src={hero.url} alt={hero.alt || "Réalisations Art Event"} className="mb-10 aspect-[21/9] w-full rounded-xl object-cover" data-testid="page-hero-image" />
      )}
      {items && shown.length === 0 && (
        <div className="mt-10"><EmptyState title="Bientôt disponible">Nos premières réalisations sont en préparation — revenez très vite.</EmptyState></div>
      )}
      <div className="mt-10 grid gap-8 md:grid-cols-2 lg:grid-cols-3">
        {shown.map((r, i) => (
          <Link key={r.slug} to={`/realisations/${r.slug}`} data-testid={`realisation-card-${r.slug}`} className={`group block ${i === 1 ? "lg:mt-12" : ""}`}>
            <div className="overflow-hidden rounded-xl">
              <img src={r.cover_image || r.image || r.images?.[0]} alt={r.title} loading="lazy" className="aspect-[4/5] w-full object-cover transition-transform duration-500 group-hover:scale-105" />
            </div>
            <p className="mt-4 text-xs uppercase tracking-[0.15em] text-muted-foreground">{(r.tags || []).join(" • ")}</p>
            <h3 className="mt-1.5 font-heading text-xl text-deepgreen">{r.title}</h3>
            <p className="text-sm text-muted-foreground">{r.place}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}